import { createFileRoute } from "@tanstack/react-router";
import HowLongDoesATmsAppointmentTake from "@/pages/articles/HowLongDoesATmsAppointmentTake";
export const Route = createFileRoute("/how-long-does-a-tms-appointment-take")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Long Does A TMS Appointment Take | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How long is a TMS session? Learn about standard TMS, SAINT TMS, and SPRAVATO appointment times and what to expect in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "How Long Does A TMS Appointment Take | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How long is a TMS session? Learn about standard TMS, SAINT TMS, and SPRAVATO appointment times and what to expect in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-long-does-a-tms-appointment-take",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-long-does-a-tms-appointment-take",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowLongDoesATmsAppointmentTake />;
}
